<template>
  <div>
    <v-row no-gutters v-if="is_required == false">
      <v-col 
            cols="auto"
            class="ml-auto">
        <v-btn text small @click="skip">Skip »</v-btn>
      </v-col>
    </v-row>
    <div class="selectBox">
      <div class="px-4">
        <v-row no-gutters v-for="(item, index) in confirmation.items" v-bind:key="index">
          <v-col cols="auto">
            <v-checkbox
                v-model="item.default"
                class="mt-0 confirmation-checkbox"
                :color="bot_setting.main_color"
                @change="resetInput"
              >
            </v-checkbox>
          </v-col>
          <v-col class="mt-1">
              <span style="white-space: pre-wrap;" v-html="item.value"></span>
          </v-col>
        </v-row>
        <div class="my-2 red--text darken-1 confirmation-message" v-if="confirmationValid == false">{{confirmation.error_message}}</div>
      </div>
      <div class="itemlist">
        <!-- <label>{{placeholder}} <span style="color:red;" v-if="is_required">※必須</span> <span style="color:rgb(121, 121, 121);" v-if="!is_required">※任意</span> 
        <strong class="error" v-if="!checkValid">{{error_message}}</strong></label> -->
        <select class="formItem" v-model="select" @change="submit">
          <option selected value="-1">{{placeholder}}</option>
          <option v-for="(item, index) in selection_options" v-bind:key="index" :value="index">{{item.title}}</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DropdownInput",
  props: ['placeholder', 'error_message', 'bot_setting', 'is_required', 'selection_options', 'label_name', 'confirmation'],

  created(){
    this.checkValid = true
    
  },

  data: () =>({
    select: -1,
    options:[],
    checkValid: true,
    confirmationValid: true,
    //error_message: 'Please select an option',
  }),


  methods: {
    skip(){
      this.$emit('skip_input_submitted')
    },
    submit(){
      //console.log(this.select)
      if (this.select >=0){
        this.checkValid = true
        if (this.validateConfirmation() == true) {
          var emitValue = {user_chat_message: this.selection_options[this.select].title, user_chat_value:this.selection_options[this.select].value}
          this.$emit('dropdown_input_submitted', emitValue)
        }
      }else{
        this.checkValid = false
      } 
    },
    validateConfirmation(){
      this.confirmationValid = true
      for(var i=0; i < this.confirmation.items.length; i++){
        if (this.confirmation.items[i].default == false){
          this.confirmationValid = false
        }
      }
      if (this.confirmationValid == true) {
        return true
      }
      return false
    },
    resetInput(){
      this.select = -1
    },
    isFinalQuestion(){
      if (this.label_name.indexOf('final') === 0){
        return true
      }else{
        return false
      }
    }
  },
  watch:{
    // select: function(){
    //   this.checkValid = true
    // }
  }
}
</script>